export default __webpack_public_path__ + "static/media/text-modal.8a2ccf3c.svg";